export const GROWTH_ANALYTICS_CHANNEL = 'growth';
export const PEOPLE_TEAMS_ANALYTICS_CHANNEL = 'peopleTeams';
